import WhatsAppSipQueuesAPI from 'dashboard/api/whatsappSip/queues';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isAddingMember: false,
    isRemovingMember: false,
    isPausingMember: false,
  },
};

export const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getById: $state => id => $state.records.find(r => r.id === id),
};

export const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await WhatsAppSipQueuesAPI.get();
      const queues = data.queues || [];
      commit('SET_RECORDS', queues);
      return queues;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async show(_, id) {
    const { data } = await WhatsAppSipQueuesAPI.show(id);
    return data.queue || data;
  },

  async create({ commit }, queueData) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await WhatsAppSipQueuesAPI.create(queueData);
      const queue = data.queue;
      commit('ADD_RECORD', queue);
      return queue;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, data: updateData }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await WhatsAppSipQueuesAPI.update(id, updateData);
      const queue = data.queue || data;
      commit('UPDATE_RECORD', queue);
      return queue;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await WhatsAppSipQueuesAPI.delete(id);
      commit('DELETE_RECORD', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  async addMember({ commit }, { id, extension }) {
    commit('SET_UI_FLAG', { isAddingMember: true });
    try {
      const { data } = await WhatsAppSipQueuesAPI.addMember(id, extension);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isAddingMember: false });
    }
  },

  async removeMember({ commit }, { id, extension }) {
    commit('SET_UI_FLAG', { isRemovingMember: true });
    try {
      const { data } = await WhatsAppSipQueuesAPI.removeMember(id, extension);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isRemovingMember: false });
    }
  },

  async pauseMember({ commit }, { id, extension, reason }) {
    commit('SET_UI_FLAG', { isPausingMember: true });
    try {
      const { data } = await WhatsAppSipQueuesAPI.pauseMember(
        id,
        extension,
        reason
      );
      return data;
    } finally {
      commit('SET_UI_FLAG', { isPausingMember: false });
    }
  },

  async unpauseMember({ commit }, { id, extension }) {
    commit('SET_UI_FLAG', { isPausingMember: true });
    try {
      const { data } = await WhatsAppSipQueuesAPI.unpauseMember(id, extension);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isPausingMember: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  SET_RECORDS($state, records) {
    $state.records = records;
  },

  ADD_RECORD($state, record) {
    $state.records = [record, ...$state.records];
  },

  UPDATE_RECORD($state, record) {
    const index = $state.records.findIndex(r => r.id === record.id);
    if (index !== -1) {
      $state.records.splice(index, 1, { ...$state.records[index], ...record });
    }
  },

  DELETE_RECORD($state, id) {
    $state.records = $state.records.filter(r => r.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
